import { Grid, Typography } from '@mui/material';

const ContentBuilderRow = ({
    title,
    subtitle,
    content,
}: {
    title: string;
    subtitle: string;
    content: React.ReactNode;
}) => (
    <Grid container mt={3} rowSpacing={1} columnSpacing={3}>
        <Grid item xs={12}>
            <Typography variant="h5">{title}</Typography>
        </Grid>
        <Grid item xs={12} md={4} xl={4}>
            <Typography variant="body2">{subtitle}</Typography>
        </Grid>
        <Grid item xs={12} md={8} xl={6}>
            {content}
        </Grid>
    </Grid>
);

export default ContentBuilderRow;
